import React, { useState, useEffect, forwardRef } from "react";
import "./CodeHistory.css";
import { useSelector, useDispatch } from "react-redux";
import FileIcon from "../../../common/assets/images/filefolder.png";
import {
  clearCodePathHistory,
} from "../CodeSearch/redux/codeSearchSlice";

const CodeHistory = () => {
  const codePathHistory = useSelector(
    (state) => state.codeSearch.codePathHistory
  );
  const dispatch = useDispatch();
  const showFinalScreen = useSelector(
    (state) => state.codeSearch.finalShowScreen
  );
  // Log codePathHistory updates in CodeHistory
  // useEffect(() => {
  //   console.log("CodeHistory received codePathHistory:", JSON.stringify(codePathHistory, null, 2));
  // }, [codePathHistory]);

  const handleClearHistory = () => {
    dispatch(clearCodePathHistory());
  };
  

  // Initialize dropdown states for each tree (open first tree by default)
  const initialDropdownStates = codePathHistory.reduce((acc, _, index) => {
    acc[index] = true; // Open first tree, close others
    return acc;
  }, {});
  useEffect(() => {
    const updatedDropdownStates = codePathHistory.reduce((acc, _, index) => {
      acc[index] =
        dropdownStates[index] !== undefined ? dropdownStates[index] : true;
      return acc;
    }, {});
    setDropdownStates(updatedDropdownStates);
  }, [codePathHistory]);

  const [dropdownStates, setDropdownStates] = useState(initialDropdownStates);

  const toggleDropdown = (index) => {
    setDropdownStates({
      ...dropdownStates,
      [index]: !dropdownStates[index],
    });
  };
  // Replace category names
  const getCategoryDisplay = (category) => {
    if (category === "Additional Diagnoses") return "ICD-10-AM Diagnosis Codes";
    if (category === "Procedure Codes") return "ACHI Codes";
    return category;
  };
  // Recursive function to render nodes
  const renderNode = (node, depth = 0) => {
      if (
    !node ||
    node.description === "" ||
    node.description === "No or already coded"
  )
    return null; //Skip this node completely
    const indentStyle = { marginLeft: `${depth * 1}px` };

    return (
      <div key={node.timestamp} className="history-item-wrapper">
        <div className="history-item-content" style={indentStyle}>
          <span className="history-item-icon">
            <img src={FileIcon} alt="folder" />
          </span>
          <div>
            {/* Always show category */}
            {node.category !== null &&
              !(
                typeof node.description === "string" &&
                node.description.endsWith("-")
              ) && (
                <p className="history-item-category">
                  {getCategoryDisplay(node.category)}
                </p>
              )}

            {/* If final screen, show name + description, else just name */}
            <p className="history-item-code">
              {node.category &&
              !node.isFromTabular &&
              !(
                typeof node.description === "string" &&
                node.description.endsWith("-") 
              ) ? (
                <>
                  {/* show code-description only if they are different */}
                  {node.code}
                  {node.description && node.description !== node.code
                    ? `-${node.description}`
                    : ""}
                </>
              ) : node?.isFromTabular && node.category ? (
                <>
                  {/* show description - code, but avoid duplicate if same */}
                  {node.description && node.description !== node.code
                    ? `${node.description} - `
                    : ""}
                  {node.code}
                </>
              ) : (
               
                node.isFromTabular ? node.description:node.code
              )}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="history-container">
      {codePathHistory.map((tree, index) => (
        <div key={index} className="history-dropdown-container">
          {renderNode(tree, 0, index)}
        </div>
      ))}
    </div>
  );
};

export default CodeHistory;
